@file:OptIn(ExperimentalTime::class)

package com.macrofocus.eflux.ui.data

import com.macrofocus.eflux.time.TimeTracker
import com.macrofocus.eflux.toInstant
import com.macrofocus.eflux.toRawString
import mui.material.*
import mui.material.styles.Theme
import mui.material.styles.useTheme
import mui.system.sx
import react.FC
import react.Props
import react.ReactNode
import web.cssom.FontFamily
import web.cssom.FontSize
import kotlin.time.ExperimentalTime
import kotlin.time.Instant

external interface DateTimeButtonProps : Props {
    var timeTracker: TimeTracker
    var logicalBranchId: Instant
}

val DateTimeButton = FC<DateTimeButtonProps> { props ->
    val fill = false
    val theme = useTheme<Theme>()

    val riskTime = props.logicalBranchId

    if(riskTime != null) {
        val minutes = minuteIntervalsBetween(props.timeTracker.maxDateTime.value.toRawString().toInstant(), riskTime)
        Tooltip {
            title = ReactNode(riskTime.toString())
            placement = TooltipPlacement.left

            Badge {
//                if(line.assetCount != null) {
//                    badgeContent = ReactNode(line.assetCount.toString())
//                    color = BadgeColor.error
//                }

                Button {
                    sx {
//                        if(fullName) {
//                            textTransform = None.none
//                        } else {
                            fontFamily = "'JetBrains Mono', monospace".unsafeCast<FontFamily>()
                            fontSize = FontSize.xSmall
//                        }
//                        if(fill) {
//                            backgroundColor = dataLoader.getColor(line, theme).toKotlinJS()
//                            "&:hover" {
//                                backgroundColor = dataLoader.getColor(line, theme).brighter().toKotlinJS()
//                            }
//                        } else {
//                            backgroundColor = (theme.asDynamic().substationFillColor as MkColor).toKotlinJS()
//                            borderColor = dataLoader.getColor(line, theme).toKotlinJS()
//                            "&:hover" {
//                                borderColor = dataLoader.getColor(line, theme).brighter().toKotlinJS()
//                            }
//
//                        }
                    }

                    variant = ButtonVariant.outlined
                    size = Size.small
//                    onPointerEnter = {
//                    }
//                    onPointerLeave = {
//                    }
                    onClick = {
                        props.timeTracker.timeSliderReleased(minutes.toInt())
                    }
                    +formatDuration(minutes)
                }
            }
        }
    }
}

fun minuteIntervalsBetween(start: Instant, end: Instant): Long {
    val duration = end - start
    return duration.inWholeMinutes
}

fun formatDuration(minutes: Long): String {
    val absMinutes = kotlin.math.abs(minutes)
    val sign = if (minutes < 0) "-" else " "
    val hours = sign + (absMinutes / 60).toString()
    val mins = (absMinutes % 60).toString().padStart(2, '0')
    val h = hours.padStart(3, ' ')

    return "$h:$mins"
}
